// removed by extract-text-webpack-plugin
module.exports = {"container":"_2gEWGUHekpENDMekE1E8ap","grid":"_3o8G07QQvwUvM1_6u99umN","headline":"_3F-QmGpEbMljLynbeb7Sd1","text":"_3QF-C-brkzwXmB_3sZ8E9q","substackContainer":"_2d8e5A0zhy-0R27wdDgGDJ","socialContainer":"_1oAjp5jY95fl7Fs4ZcH3Jq","socialLink":"YsxLRlqr67NRzO0sspQfB","socialIcon":"_3un8eiHej4EJMJfAO_xiQR","socialText":"_3fCUZ14DPslh5--l43sCQk","privacyPolicy":"_2QC-H2ST8bn88RKD8psbRD","copyright":"_2Vt6IhmqT2UgSMoUETuP_G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/styles.css
// module id = 301
// module chunks = 0